module.exports = __webpack_public_path__ + "static/media/tornado_small.520705c5.mp4";